module.exports = __webpack_public_path__ + "static/media/outsideView4.71fb9d1a.jpg";